<template>
  <div class="multiple-choice-us" v-if="isUs">
    <div v-for="option in options" v-bind:key="option.value">
      <div :class="['multiple-choice-option', isOptionSelected(option.value) ? 'active' : '']">
        <label :for="id + '-option-' + option.value">
          <input
            type="radio"
            :name="id + '-option'"
            v-on:click="onOptionSelect(option)"
            :id="id + '-option-' + option.value"
            :checked="isOptionSelected(option.value)"
          />
          <span class="checkmark"></span>
          <span class="option-label">{{ option.label }}</span>
          <span
            v-if="option.indicatorLabel"
            class="float-right pr-[32px] font-medium text-[13px]"
            :style="{ color: isOptionSelected(option.value) ? '#0f0c0c' : option.indicatorColour }"
            >{{ option.indicatorLabel }}</span
          >
          <span
            v-if="option.indicatorColour"
            class="absolute w-[4px] h-[60%] rounded right-[10px] top-[20%]"
            :style="{ backgroundColor: isOptionSelected(option.value) ? '#0f0c0c' : option.indicatorColour }"
          ></span>
        </label>
      </div>
      <div class="option-warning pl-10 my-5" role="alert" v-if="option.warningText && isOptionSelected(option.value)">
        {{ option.warningText }}
      </div>
    </div>
  </div>
  <div v-else>
    <div class="multi-choice-wrapper">
      <div v-for="option in options" v-bind:key="option.value">
        <div :class="['multiple-choice-option ', isOptionSelected(option.value) ? 'active' : '']">
          <label :for="id + '-option-' + option.value" class="radio-btn-set buttons-wrapped">
            <input
              type="radio"
              :name="id + '-option'"
              v-on:click="onOptionSelect(option)"
              :id="id + '-option-' + option.value"
              :checked="isOptionSelected(option.value)"
            />
            <span class="checkmark"></span>
            <span class="option-label">{{ option.label }}</span>
            <span
              v-if="option.indicatorLabel"
              class="float-right pr-[32px] font-medium text-[13px]"
              :style="{ color: isOptionSelected(option.value) ? '#0f0c0c' : option.indicatorColour }"
              >{{ option.indicatorLabel }}</span
            >
            <span
              v-if="option.indicatorColour"
              class="absolute w-[4px] h-[60%] rounded right-[10px] top-[20%]"
              :style="{ backgroundColor: isOptionSelected(option.value) ? '#0f0c0c' : option.indicatorColour }"
            ></span>
          </label>
        </div>
      </div>
    </div>
    <div
      v-if="selectedOptionWarning"
      style="max-width: 80%; margin-top: 10px"
      class="ui-message ui-message-warn ui-widget ui-corner-all"
    >
      <span class="ui-message-warn-icon" />
      <span class="ui-message-warn-detail" v-html="selectedOptionWarning" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["value", "options", "id"],
  inject: ["isUs"],
  data: function () {
    return {
      answer: this.value,
      selectedOption: null,
    };
  },
  computed: {
    selectedOptionWarning() {
      return this.selectedOption?.warningText;
    },
  },
  methods: {
    onOptionSelect: function (option) {
      this.answer = option.value;
      this.selectedOption = option;
    },
    isOptionSelected: function (value) {
      return this.answer === value;
    },
    isAnyOptionSelected: function () {
      return this.answer;
    },
  },
  watch: {
    answer: function (newValue) {
      this.$emit("input", newValue);
    },
  },
});
</script>
